/* ==========================================================================
   PanelAccommodation > Template
   ========================================================================== */

/* Import modules */
const { html } = require('common-tags');

const { sanitizeObject } = require('@bluekiri/alexandria-contrib-components/helpers/sanitize');
const { prepareDataConfig, addStyle, addData, randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');

const ButtonTemplate = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/template');
const PanelRoomTemplate = require('../panel-room/template');

const configuration = require('./client/js/config');

const renderAddBtn = (content, hasAdd, context) => {
    if (!hasAdd) return html('');

    const buttonData = addStyle(addData({ content }, { type: configuration().type.addBtn }), [
        configuration().css.addBtn
    ]);

    return ButtonTemplate(buttonData, context);
};

const renderPanelRoom = (data, context) => {
    const { literals, people, hasDelete = false, hasTitle, type } = data;

    const dataRooms = addStyle(
        addData(
            {
                config: {
                    hasTitle,
                    hasDelete,
                    literals
                },
                people
            },
            { type }
        ),
        [configuration().css.room]
    );

    return PanelRoomTemplate(dataRooms, context);
};

const renderRooms = (data, context) => {
    if (!data.people || data.people.length === 0) return html('');

    const { config = {}, rooms = [], people = [] } = data;
    const { literals = {}, hasTitle = configuration().hasTitle } = config;
    const { roomLabel = '#number#' } = literals;
    const hasRooms = rooms.length > 0;

    if (!hasRooms) {
        const label = roomLabel.replace('#number#', '1');
        return renderPanelRoom(
            {
                literals: { ...literals, roomLabel: label },
                people,
                type: randomId(randomId(configuration().type.room))
            },
            context
        );
    }

    const template = rooms.map((room, ind) => {
        const { people: passengers = [] } = room;
        const hasDelete = ind >= 1;
        const label = roomLabel.replace('#number#', ind + 1);

        const roomData = {
            hasTitle,
            hasDelete,
            type: randomId(randomId(configuration().type.room)),
            literals: {
                ...literals,
                roomLabel: label
            },
            people: passengers.map((item, index) => ({ ...people[index], ...item }))
        };

        return renderPanelRoom(roomData, context);
    });

    return html(template);
};

/**
 * PanelAccommodation template
 * @param {object} data Object containing the data model for this component.
 * @param {object} context The general context object.
 * @returns {object} Additional data to have available in the template
 */
module.exports = function Template(data, context) {
    /* Data */
    const { config = {}, rooms = [], people } = data;
    const { styles = [], literals = {} } = config;
    const style = configuration().css.self;

    const { dataType } = prepareDataConfig(config.data);
    const dataTypAttr = dataType ? html(`data-type="${dataType}"`) : html('');

    const { hasAdd = configuration().hasAdd } = config;
    const { addRoom = '' } = literals;

    const dataConfig = sanitizeObject({
        context,
        ...config,
        rooms,
        people
    });
    const dataConfigAttr = `data-config='${JSON.stringify({ ...dataConfig })}'`;

    /* -Template */
    return html(`
        <div class='${[style, ...styles].join(' ').trim('')}'
            data-component='${configuration().component}'
            ${dataTypAttr}
            ${dataConfigAttr}>
            <div class="${style}__rooms" ${configuration().hooks.rooms}>
                ${renderRooms(data, context)}
            </div>

            ${renderAddBtn(addRoom, hasAdd, context)}
        </div>
    `);
};
